export const authorizedFetch = (accessToken, url, options = {}) => {
    if (!accessToken || typeof accessToken !== "string") {
        throw new Error("Access Token fehlt.");
    }

    const normalizedAccessToken = accessToken.trim();
    const headers = new Headers(options.headers);

    const authorizationValue = /^Bearer\s/i.test(normalizedAccessToken)
        ? normalizedAccessToken
        : `Bearer ${normalizedAccessToken}`;

    headers.set("Authorization", authorizationValue);

    return fetch(url, {
        ...options,
        headers,
    });
};